import {Cache} from "./Cache";

class CallHushiAction extends Cache {
    constructor() {
        super(true);
        this.key += 'callhushi';
    }
}

export const callHushiActionCache = new CallHushiAction();
